import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { Company } from '../../interfaces/Company/Company';
import { getCompanies } from '../../api/Company';

interface CompanyDropdownProps {
  label?: string;
  companyID: number;
  onChange: (id: number) => void;
}

export const CompanyDropdown = (props: CompanyDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    setLoading(true);
    getCompanies()
      .then((c) => setCompanies(c))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.companyID.toString()}
          onChange={(e) => {
            const s = e.target.value;
            props.onChange(Number(s));
          }}
        >
          {companies.map((company) => (
            <MenuItem key={company.id} value={company.id.toString()}>
              {company.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
